import { render, staticRenderFns } from "./checkBox.vue?vue&type=template&id=1666db81&scoped=true&"
import script from "./checkBox.vue?vue&type=script&lang=js&"
export * from "./checkBox.vue?vue&type=script&lang=js&"
import style0 from "./checkBox.vue?vue&type=style&index=0&id=1666db81&lang=less&scoped=true&"
import style1 from "./checkBox.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1666db81",
  null
  
)

export default component.exports